import { render, staticRenderFns } from "./PFSettlementDisbursed.vue?vue&type=template&id=d00bf720"
import script from "./PFSettlementDisbursed.vue?vue&type=script&lang=js"
export * from "./PFSettlementDisbursed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports